var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneUsageScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6745 16.5553C22.9381 15.7132 22.1921 14.4303 20.9238 14.569",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0664 16.3408C26.1858 14.1158 24.2113 11.0631 20.9238 11.2762",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4182 16.339C29.6122 12.6966 26.5435 7.87477 20.9434 7.89459",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 16.3386C33.0273 11.2938 28.7103 4.59375 20.9766 4.59375",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.158 20.1695L12.4518 19.2081C11.7405 18.1278 11.6063 17.4191 12.5214 16.4726L14.4959 14.4309C14.7445 14.1781 14.7445 13.7767 14.4959 13.524L9.52237 8.55349C9.26375 8.2958 8.84598 8.30076 8.59233 8.5634C8.59233 8.5634 7.19975 10.0204 6.73722 10.506C5.12581 12.2058 4.94179 14.8422 6.06579 16.8938C6.39405 17.4934 6.68748 18.1377 7.09531 18.8364C8.33868 20.9822 10.5867 23.8317 11.9246 25.1746C13.3271 26.587 15.774 28.6535 18.1862 30.0312C19.8772 30.9925 21.3145 31.6566 22.3092 31.7557C25.7558 32.1026 27.9143 29.5207 28.6902 28.4255C28.8742 28.1678 28.8444 27.816 28.6156 27.593C27.5761 26.5721 24.781 23.792 23.7117 22.7414C23.468 22.4986 23.0751 22.4937 22.8215 22.7266C22.3092 23.1924 21.4687 23.9704 20.852 24.6642C20.0512 25.5661 19.0267 25.5315 18.1812 24.907C17.7386 24.5849 16.4405 23.5889 16.4405 23.5889",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneUsageScore);
export default __webpack_public_path__ + "static/media/ic_phone_usage_score.8ea11b4e9fc06829011838d8e6eb77da.svg";
export { ForwardRef as ReactComponent };